import { css } from '@/styled-system/css';

export const photoCarouselRootStyles = css.raw({
  'display': 'flex',
  'position': 'relative',
  'flex': 1,
  'flexDirection': 'column',
  'width': '100%',
  'height': '100%',
  'overflow': 'hidden',

  '& > .c11n_anchor': {
    height: '100%',
  },

  // Only show nav buttons to mouse users
  '& > .c11n_photo-carousel__nav-controls': {
    display: 'flex',
    opacity: 0,
    // Use same transition timing as Property Card body's box-shadow
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'opacity',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.200}',
    },
    transitionTimingFunction: '{easings.ease}',
    // Ensure touch users get full photo area for swiping
    zIndex: -1,
  },

  // Make sure nav buttons don't appear on touch screens after a tap.
  '_hoverMouse': {
    _hoverNotDisabled: {
      '& > .c11n_photo-carousel__nav-controls': {
        opacity: 1,
        zIndex: 1,
      },
    },
  },

  /*
   * The nav buttons are the keyboard interface for the carousel, so they have to
   * be visible once focused -- revealing them on hover alone would leave keyboard
   * users tabbing to an invisible control (WCAG 2.4.7).
   */
  '&:has(> .c11n_photo-carousel__nav-controls:focus-within)': {
    '& > .c11n_photo-carousel__nav-controls': {
      opacity: 1,
      zIndex: 1,
    },
  },

  '&:has(a:focus-within > .c11n_property-card__photo)': {
    boxShadow: 'focus',
  },
});
